import { apiInstance } from "./ApiInstance";
import { pageLimit } from "../Utils/helper";

export const getAllCasesListVendor = async (route, offset) => {
  let { data = {} } = await apiInstance.get(
    `vendor/list/master?offset=${offset}&limit=${pageLimit}`
  );
  return data;
};

export const getAllCasesSegmentInfoVendor = async (
  route,
  vendorCompanyId,
  payload
) => {
  let { data = {} } = await apiInstance.get(
    `vendor/segment/${route}?vendor_company_id=${vendorCompanyId}`,
    payload
  );
  return data;
};

export const vendorOnboard = async (payload) => {
  let { data = {} } = await apiInstance.post("vendor/vendor-onboard", payload);
  return data;
};

export const addVendorLocation = async (payload) => {
  let { data = {} } = await apiInstance.post("vendor/add-vendor-location", payload);
  return data;
};

export const getStateListVendor = async () => {
  let { data = {} } = await apiInstance.get(`api/utils/state-list`);
  return data;
}

export const getCitiesByStateVendor = async (stateId) => {
  let { data = {}} = await apiInstance.get(`api/utils/city-by-state-list?state_id=${stateId}`);
  return data; 
}

export const addVendorServiceLocation = async (payload) => {
  let { data = {} } = await apiInstance.post(`/vendor/add-vendor-location`, payload);
  return data;
}

export const getVendorDetailsById = async (vendorId) => {
  let { data = {} } = await apiInstance.get(`/vendor/get-vendor/${vendorId}`);
  return data;
}

export const editVendorDetailsById = async (payload) => {
  let { data = {} } = await apiInstance.post(`vendor/vendor-update`, payload);
  return data;
}

export const activateDeactivateVendorById = async (id, status) => {
  let { data = {} } = await apiInstance.post(`/vendor/update-vendor-status/${id}`, {
    isActive: status
  });
  return data;
}

export const fetchAllVendors = async (lobId, state, city) => {
  const encodeState = encodeURIComponent(state);
  const encodeCity = encodeURIComponent(city);
  let { data = {} } = await apiInstance.get(`/vendor/fetch-vendor-details?lob_id=${lobId}&state=${encodeState}&city=${encodeCity}`)
  return data;
}

export const initialVendorList = async (lobId) => {
  let { data = {} } = await apiInstance.get(`/vendor/fetch-vendor-details?lob_id=${lobId}`)
  return data;
}

export const getServiceableLocations = async (payload) => {
  let { data = {} } = await apiInstance.post(`/vendor/get-vendor-service-location`, payload);
  return data;
}

export const editVendorServiceLocation = async (payload) => {
  let { data = {} } = await apiInstance.post(`/vendor/edit-vendor-service-location`, payload);
  return data;
};

export const removeVendorServiceLocation = async (payload) => {
  let { data = {} } = await apiInstance.post(`/vendor/remove-vendor-service-location`, payload);
  return data;
};

export const getSubProductsByLob = async (lobId) => {
  let { data = {} } = await apiInstance.get(`/api/lobs/${lobId}/sub_products`);
  return data
}